import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { SharedService } from '../service/shared.service';

/**
 * 是否是管理员验证
 *
 * @version 1.0
 * @since 1.0
 */
@Injectable()
export class ManagerGuardGuard {
  private sharedSrv = inject(SharedService);

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    return this.sharedSrv.user.isSuper || this.sharedSrv.user.isOperateInSchool;
  }
}
